import { useContext } from 'react';

import { NavigationSidebarContext } from '../contexts';

export function useNavigationSidebarContext() {
  const context = useContext(NavigationSidebarContext);

  if (!context) {
    throw new Error('useNavigationSidebarContext() must be called within a <NavigationSidebar /> component.');
  }

  return context;
}
